const nextUrl = document.getElementById('paginateNext');
let next_url = nextUrl.getAttribute("data-next-url");

const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];
async function getNextPage() {
  try {
    let res = await fetch(next_url);
    return await res.text();
  } catch (error) {
    console.log(error);
  }
}

async function loadMoreProducts() {
  
const products_on_page = document.getElementById('product-grid');

  // console.log('1. loadMoreProducts');
  // console.log('2. products_on_page =',products_on_page);
  // console.log('3. nextUrl =',nextUrl);
  // console.log('4. load_more_btn =',load_more_btn);
  // console.log('5. load_more_spinner =', load_more_spinner);

  document.getElementsByClassName('load-more_btn')[0].style.display = 'none';
  document.getElementsByClassName('load-more_spinner')[0].style.display = 'block';
  let nextPage = await getNextPage();

  const parser = new DOMParser();
  const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

  document.getElementsByClassName('load-more_spinner')[0].style.display = 'none';

  const productgrid = nextPageDoc.getElementById('product-grid'); 
  const new_products = productgrid.getElementsByTagName('li');
  const items = productgrid.getElementsByTagName('li');
  let productHTML = [];

  // because HTMLCollection is array-like, we loop with for
  for (let i = 0; i < items.length; i++) {
    productHTML.push(items[i].outerHTML); 
  }

  // console.log("productHTML =",productHTML);
  const newUrl = nextPageDoc.getElementById('paginateNext');
  const new_url = newUrl.getAttribute("data-next-url");
  // console.log("new_url =",new_url);
  if (new_url) {
    document.getElementsByClassName('load-more_btn')[0].style.display = 'flex';
  }

   // append them all to products_on_page
  productHTML.forEach(html => {
    products_on_page.insertAdjacentHTML("beforeend", html);
  });
  next_url = new_url;
  // console.log("next_url =",next_url);
  setTimeout(() => {
    if (lenis) { 
        lenis.resize();
        console.log('Lenis resized after window loaded.');
    }
    // $("variant-selects input:checked").change();  
  }, 100);
}

// function bindLoadMore() {
//   // console.log('bindLoadMore');
//   if (window.location.href.includes("&filter.v")){
//     next_url = window.location.href + "&page=2";
//   }
//   else{
//     next_url = "/collections/all-products?page=2";
//   }
//   let $btn = $('.load-more_btn').first();
//   if ($btn.length) {
//     $btn.off('click').on('click', loadMoreProducts); // ensure rebind
//   }
// }

// // Run every time filter replaces products
// $(document).on('product-loaded', function () {
//   setTimeout(() => {
//     $("variant-selects input:checked").change();  
//   }, 100);
//   bindLoadMore();
// });